module.exports = __webpack_public_path__ + "static/media/no-results.0033cc21.svg";